/**
 * Class to handle the navigation services
 */
export default class NavigationService {
  private static _navigator: any;

  /**
   * Set up project navigation reference
   * @param {any} navigatorRef
   */
  static setTopLevelNavigator(navigatorRef: any) {
    this._navigator = navigatorRef;
  }

  /**
   * Use navigation reference to navigate to specific route
   * @param {string} routeName
   * @param {any} state
   */
  static navigate(routeName: string, state?: any) {
    if (this._navigator) {
      if (state) {
        this._navigator.push({pathname: routeName, state});
      } else {
        this._navigator.push(routeName);
      }
    }
  }

  /**
   * Use navigation reference to return to previous route
   */
  static goBack() {
    if (this._navigator) {
      this._navigator.goBack();
    }
  }
}
